import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth, API } from '../App';
import { t } from '../i18n';

const ROUTE_CLASS = (r) => {
  if (['FAQ', 'Semantic Cache', 'Metadata DB', 'Summary Lookup'].includes(r)) return 'free';
  if (r === 'Claude Sonnet') return 'legal';
  return 'ai';
};

export default function AuditLogPage() {
  const { lang } = useAuth();
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    axios.get(`${API}/audit/queries`).then(r => { setRows(r.data); setBusy(false); }).catch(() => setBusy(false));
  }, []);

  const filtered = rows.filter(r =>
    !search ||
    r.question.toLowerCase().includes(search.toLowerCase()) ||
    r.user_email.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="fade-up" data-testid="audit-log-page">
      <div className="data-label accent-line text-[#DDA079] mb-3">{t(lang, 'nav.dept_audit')}</div>
      <h1 className="font-headings text-4xl text-white mb-2">Query Audit Log</h1>
      <p className="text-slate-400 mb-6">Immutable trail of every query in your scope. Filter, audit and trace cost attribution.</p>

      <input
        data-testid="audit-search"
        value={search}
        onChange={e => setSearch(e.target.value)}
        placeholder="Search by question or user…"
        className="v-input max-w-md mb-6"
      />

      {busy ? (
        <div className="space-y-2">{[...Array(6)].map((_, i) => <div key={i} className="skeleton h-12 rounded-sm" />)}</div>
      ) : filtered.length === 0 ? (
        <div className="text-slate-500 text-[14px]">{t(lang, 'common.empty')}</div>
      ) : (
        <div className="v-card overflow-hidden">
          <table className="w-full text-[12px]">
            <thead>
              <tr className="border-b border-white/10 text-left">
                <th className="data-label px-4 py-3">When</th>
                <th className="data-label px-4 py-3">User</th>
                <th className="data-label px-4 py-3">Question</th>
                <th className="data-label px-4 py-3">Route</th>
                <th className="data-label px-4 py-3 text-right">Cost</th>
                <th className="data-label px-4 py-3 text-right">Conf</th>
                <th className="data-label px-4 py-3 text-right">Time</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((r, i) => (
                <tr key={r.id} data-testid={`audit-row-${i}`} className="border-b border-white/5 hover:bg-white/[0.02]">
                  <td className="px-4 py-3 font-mono text-slate-400 whitespace-nowrap">
                    {new Date(r.ts).toLocaleString('en-IN', { dateStyle: 'short', timeStyle: 'short' })}
                  </td>
                  <td className="px-4 py-3 text-slate-300">{r.user_name}</td>
                  <td className="px-4 py-3 text-white max-w-md truncate">{r.question}</td>
                  <td className="px-4 py-3"><span className={`v-badge ${ROUTE_CLASS(r.route)}`}>{r.route}</span></td>
                  <td className={`px-4 py-3 text-right font-mono ${r.cost_inr === 0 ? 'text-emerald-400' : 'text-white'}`}>
                    ₹{r.cost_inr.toFixed(2)}
                  </td>
                  <td className="px-4 py-3 text-right font-mono text-slate-400">{Math.round(r.confidence * 100)}%</td>
                  <td className="px-4 py-3 text-right font-mono text-slate-500">{r.elapsed_ms}ms</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
